import { styled } from '@mui/material/styles';
import MuiDialogContent from '@mui/material/DialogContent';

export const DialogActions = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 4.5, 6),
}));
